import {
  ChainFullIds,
  OperationTypes,
  type Transaction,
  TransactionDirections,
  mutezToTez,
} from "@umami/chains";
import { type ShieldedTransaction } from "@umami/state";

export const normalizeShieldedTransaction = (
  transaction: ShieldedTransaction,
  index: number,
  explorerUrl: string
): Transaction => {
  const isIncoming = transaction.type === "incoming";
  const amount = mutezToTez(transaction.value.toString()).toString();

  return {
    hash: `sapling-${transaction.position}-${index}`,
    from: "",
    to: "",
    amount,
    explorerUrl,
    id: `sapling-${transaction.position}-${index}`,
    chainId: ChainFullIds.TEZOS,
    operationType: OperationTypes.SAPLING,
    ticker: "XTZ",
    txDirection: isIncoming ? TransactionDirections.RECEIVE : TransactionDirections.SEND,
    memo: transaction.memo || undefined,
  };
};
